var map = {
	"./animal.svg": "./src/images/animal.svg",
	"./arrow.svg": "./src/images/arrow.svg",
	"./bicycle.svg": "./src/images/bicycle.svg",
	"./boat.svg": "./src/images/boat.svg",
	"./bus.svg": "./src/images/bus.svg",
	"./car.svg": "./src/images/car.svg",
	"./crane.svg": "./src/images/crane.svg",
	"./default.svg": "./src/images/default.svg",
	"./helicopter.svg": "./src/images/helicopter.svg",
	"./main-bg.png": "./src/images/main-bg.png",
	"./motorcycle.svg": "./src/images/motorcycle.svg",
	"./offroad.svg": "./src/images/offroad.svg",
	"./person.svg": "./src/images/person.svg",
	"./pickup.svg": "./src/images/pickup.svg",
	"./plane.svg": "./src/images/plane.svg",
	"./ship.svg": "./src/images/ship.svg",
	"./tractor.svg": "./src/images/tractor.svg",
	"./train.svg": "./src/images/train.svg",
	"./tram.svg": "./src/images/tram.svg",
	"./trolleybus.svg": "./src/images/trolleybus.svg",
	"./truck.svg": "./src/images/truck.svg",
	"./van.svg": "./src/images/van.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync \\.(png%7Cjpe?g%7Csvg)$";